import type { DialogOptions, DialogService } from '@patsnap/tahiti-core';

export interface FigureAnnotationDialogOptions extends DialogOptions {
    title?: string;
}

export interface FigureAnnotationDialogOutput {

}

export const FigureAnnotationService = Symbol.for('FigureAnnotationService');

export interface FigureAnnotationService extends DialogService<FigureAnnotationDialogOptions, FigureAnnotationDialogOutput> {}
